import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { EmailTemplate } from './types';

const state = {
  emailTemplates: [] as EmailTemplate[],
  loadingEmailTemplateList: false as boolean,
  loadingTemplateCreateUpdate: false as boolean,
  deleteTemplateLoader: false as boolean,
  blankEmailTemplateJson: null,
  emailTemplatesFor: '' as string
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
